<template>
  <CardContainer>
    <div slot="header">
      <CommonForm @search="formSearch" :form-json="formjson" />
    </div>
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      @change="handleTableChange"
      :operation="operation"
      @operation="handleOperation"
      :table-json="tablejson"
    >
    </CommonTable>

    <LogWapDetail v-if="visible" :visible.sync="visible" :row="row" />
  </CardContainer>
</template>

<script>
import formjson from './Model/Formjson.LogWeb'
import tablejson from './Model/Tablejson.LogWeb'
import formTableMixin from '@/mixins/formTableMixin'
import { getRoleByOperationCode } from '@/authorized'

import LogWapDetail from './LogWapDetail'
export default {
  mixins: [formTableMixin],
  props: {
    role: {
      type: Array
    }
  },
  components: {
    LogWapDetail
  },
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: this.$t('Common.detail'),
          icon: 'icon-detail_16',
          type: 'detail',
          hide: () => {
            return !this.detailRole
          }
        }
      ],
      needSelection: true,
      visible: false,
      queryApi: this.$api.system.log_app_list,
      row: {},
      resetPasswordVisible: false
    }
  },
  computed: {
    /********* 权限 ***********/
    // this.role 计算属性通过mixins: [getRoleFromPath] 注入
    // 导出权限
    // 详情
    detailRole() {
      let val = getRoleByOperationCode(this.role, 'detail')
      return val ? val.isPermission == 'Y' : false
    }
    /********* 权限 ***********/
  },
  methods: {
    formSearch(data, pageObj) {
      if (!data) {
        data = this.cacheData
      }
      this.search(data, pageObj, this.queryApi)
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleDetail(row) {
      this.row = row
      this.visible = true
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'detail':
          this.handleDetail(row)
          break
      }
    }
  }
}
</script>
